// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "formLabel-3OG2h";
var _3 = "notes-cHxIw";
var _4 = "wide-3F5l1";
var _5 = "selectedServices-3lmOg";
var _6 = "note-2qEOJ";
var _7 = "control-1TWeL";
var _8 = "agree-1sAQZ";
var _9 = "checkbox-3rLSm";
var _a = "active-2sIxI";
var _b = "terms-3DtNZ";
var _c = "form-333xc";
var _d = "wrapper-1Hn7W";
var _e = "formName-NtfRt";
var _f = "formEmail-1qg1r";
var _10 = "formTel-1vPh4";
var _11 = "formComment-Bex1W";
export { _1 as "__esModule", _2 as "formLabel", _3 as "notes", _4 as "wide", _5 as "selectedServices", _6 as "note", _7 as "control", _8 as "agree", _9 as "checkbox", _a as "active", _b as "terms", _c as "form", _d as "wrapper", _e as "formName", _f as "formEmail", _10 as "formTel", _11 as "formComment" }
export default { "__esModule": _1, "formLabel": _2, "notes": _3, "wide": _4, "selectedServices": _5, "note": _6, "control": _7, "agree": _8, "checkbox": _9, "active": _a, "terms": _b, "form": _c, "wrapper": _d, "formName": _e, "formEmail": _f, "formTel": _10, "formComment": _11 }
